import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function FormWizards() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'Form Stuff'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Form Wizards '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="wizardLayout1" className="mb-5">
									<h4>{'Wizard layout 1'}</h4>
									<p>
										{
											'Wizard layout include the number of step and text. Please do note that all the wizard is for uxui ONLY but do not include any javascript or backend logic.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="nav-wizards-container">
												<nav className="nav nav-wizards-1 mb-2">
													<div className="nav-item col">
														<a className="nav-link completed" href="#/">
															<div className="nav-no">{'1'}</div>
															<div className="nav-text">{'Completed step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link completed" href="#/">
															<div className="nav-no">{'2'}</div>
															<div className="nav-text">{'Second step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link active" href="#/">
															<div className="nav-no">{'3'}</div>
															<div className="nav-text">{'Active step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link disabled" href="#/">
															<div className="nav-no">{'4'}</div>
															<div className="nav-text">{'Disabled step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link disabled" href="#/">
															<div className="nav-no">{'5'}</div>
															<div className="nav-text">{'Last step'}</div>
														</a>
													</div>
												</nav>
											</div>
											<div className="card">
												<div className="card-body">{' wizard content here '}</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/form-wizards/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="wizardLayout2" className="mb-5">
									<h4>{'Wizard layout 2'}</h4>
									<p>
										{
											'Wizard layout include the number of step and text. Please do note that all the wizard is for uxui ONLY but do not include any javascript or backend logic.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="nav-wizards-container">
												<nav className="nav nav-wizards-2 mb-3">
													<div className="nav-item col">
														<a className="nav-link completed" href="#/">
															<div className="nav-text">{'1. Completed step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link active" href="#/">
															<div className="nav-text">{'2. Active step text'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link disabled" href="#/">
															<div className="nav-text">{'3. Disabled step text'}</div>
														</a>
													</div>
												</nav>
											</div>
											<div className="card">
												<div className="card-body">{' wizard content here '}</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/form-wizards/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="wizardLayout3" className="mb-5">
									<h4>{'Wizard layout 3'}</h4>
									<p>
										{
											'Wizard layout include the number of step and text. Please do note that all the wizard is for uxui ONLY but do not include any javascript or backend logic.'
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="nav-wizards-container">
												<nav className="nav nav-wizards-3 mb-2">
													<div className="nav-item col">
														<a className="nav-link completed" href="#/">
															<div className="nav-dot"></div>
															<div className="nav-title">{'Step 1'}</div>
															<div className="nav-text">{'Completed step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link completed" href="#/">
															<div className="nav-dot"></div>
															<div className="nav-title">{'Step 2'}</div>
															<div className="nav-text">{'Second step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link active" href="#/">
															<div className="nav-dot"></div>
															<div className="nav-title">{'Step 3'}</div>
															<div className="nav-text">{'Active step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link disabled" href="#/">
															<div className="nav-dot"></div>
															<div className="nav-title">{'Step 4'}</div>
															<div className="nav-text">{'Disabled step'}</div>
														</a>
													</div>
													<div className="nav-item col">
														<a className="nav-link disabled" href="#/">
															<div className="nav-dot"></div>
															<div className="nav-title">{'Step 5'}</div>
															<div className="nav-text">{'Last step'}</div>
														</a>
													</div>
												</nav>
											</div>
											<div className="card">
												<div className="card-body">{' wizard content here '}</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/form-wizards/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link" href="#wizardLayout1" data-toggle="scroll-to">
											{'Wizard layout 1'}
										</a>
										<a className="nav-link" href="#wizardLayout2" data-toggle="scroll-to">
											{'Wizard layout 2'}
										</a>
										<a className="nav-link" href="#wizardLayout3" data-toggle="scroll-to">
											{'Wizard layout 3'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FormWizards;
